module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  if(factoryKey === 'command_get_field_from_other' || factoryKey === 'command_set_field_in_other') {
    ; __append("\r\n    ")
    ;  if(factoryKey === 'command_set_field_in_other') {
    ; __append("\r\n        <div class=\"prop-header\"><span class=\"prop-label\">Set Field Settings</span></div>\r\n    ")
    ;  } else {
    ; __append("\r\n        <div class=\"prop-header\"><span class=\"prop-label\">Get Field Settings</span></div>\r\n    ")
    ;  } 
    ; __append("\r\n<div class=\"row\">\r\n    <div class=\"col-md-4 prop-sublabel-7\"><span>App</span></div>\r\n    <div class=\"col-md-5 nopadding\" style=\"padding-right: 5px!important;\">\r\n        <input type=\"text\" name=\"formOrReport\" value=\"")
    ; __append(escapeFn(formOrReportName))
    ; __append("\" readonly=\"readonly\" />\r\n    </div>\r\n    <div class=\"col-md-2 nopadding\">\r\n        <button type=\"button\" id=\"selectForm\" class=\"btn btn-default hvr-glow\" name=\"selectForm\" style=\"width:58px;\">Select</button>\r\n    </div>\r\n</div>\r\n")
    ;  } else {
    ; __append("\r\n<div class=\"prop-header\"><span class=\"prop-label\">")
    ; __append(escapeFn(sectionTitle))
    ; __append("</span></div>\r\n<div class=\"row\">\r\n    <div class=\"col-md-8 nopadding-r\" style=\"min-width: 150px; padding-right: 5px!important;\">\r\n        <input type=\"text\" name=\"formOrReport\" value=\"")
    ; __append(escapeFn(formOrReportName))
    ; __append("\" readonly=\"readonly\" />\r\n    </div>\r\n    ")
    ;  if (sectionTitle==='Show App Settings') {
    ; __append("\r\n    <div class=\"col-md-4 nopadding\" style=\"text-align: right;\">\r\n        <button type=\"button\" id=\"selectForm\" class=\"btn btn-default hvr-glow select-button\" name=\"selectForm\" style=\"max-width: 80px\">Select App</button>\r\n    </div>\r\n    ")
    ; } else if (sectionTitle === 'Show Report Settings') {
    ; __append("\r\n    <div class=\"col-md-4 nopadding\" style=\"text-align: right;\">\r\n        <button type=\"button\" id=\"selectForm\" class=\"btn btn-default hvr-glow select-button\" name=\"selectForm\" style=\"max-width: 80px\">Select Report</button>\r\n    </div>\r\n    ")
    ;  } else {
    ; __append("\r\n    <div class=\"col-md-4 nopadding\" style=\"text-align: right;\">\r\n        <button type=\"button\" id=\"selectForm\" class=\"btn btn-default hvr-glow select-button\" name=\"selectForm\" style=\"max-width: 80px\">Select</button>\r\n    </div>\r\n   ")
    ;  }
    ; __append("\r\n</div>\r\n ")
    ;  }
  }
  return __output;

}